
/* injects from baggage-loader */
require('./style.scss');

import React, { Fragment } from 'react';
import { Link } from "react-router";
import Config from '../../../config/main';

class FavoriteSlider extends React.Component {
    render() {
        let { data } = this.props;

        return (
            <Fragment>
                <ul className="favorite-comp-slider">
                    <li>
                        <div className="competitions-list-h">
                            <Link to={`/prematch/${data.sportAlias}/${data.regionId}/${data.id}`} className={`${data.regionAlias.toLowerCase()} competition-id-${data.id}`}>
                                <p>
                                    {Config.favoriteCompetitionRegion && <span>
                                        <b className={`flag-view-m icon-${data.regionAlias.toLowerCase().replace(/\s/g, '')}`} />{data.regionName}
                                    </span>}
                                    <i>{data.name}</i>
                                </p>
                            </Link>
                        </div>
                    </li>
                </ul>
            </Fragment>
        );
    }
}
export default FavoriteSlider;